import {
  Box,
  Flex,
  Text,
} from '@chakra-ui/react';
import { SPLIT_CIRCLE_COLOURS as COLOURS, e3Legend } from '@src/modules/performance/shared/constants';
import { useEffect, useState } from 'react';
import { useE3Kpi } from '@src/modules/performance/context/reports-api-hooks';
import { SplitCircleIndicator } from '@src/modules/performance/components/indicators';
import IndicatorLegend from '@src/modules/performance/components/IndicatorLegend';
import ReportHeader from './ReportHeader';

const colourMap = {
  1: COLOURS.LIGHT_BLUE,
  2: COLOURS.BLUE,
  3: COLOURS.DARK_BLUE,
  default: 'GREY',
};

const labelMap = {
  economy: 'Value for Money',
  effectiveness: 'Effectiveness',
  efficiency: 'Efficiency',
};

const informationSource = {
  title: 'Sealed Network Benchmarking',
  content: [
    {
      title: 'Value for Money',
      description:
  <Text fontSize="inherit" mb={2}>(Quality / Cost) - Compares the current network 75th percentile roughness to the amount spent per lane km on resurfacing, rehabilitation, and kerb and channel drainage over the last three years. The normalised result is compared to the rest of the peers.</Text>,
      source: null,
    },
    {
      title: 'Efficiency',
      description:
  <Text fontSize="inherit" mb={2}>(Quantity / Cost) - Compares how many lane kms of renewal work on resurfacing, rehabilitation, and kerb and channel drainage is done in the last three years to the amount spent on that renewal work in the same period. The normalised result is compared to the rest of the peers.</Text>,
      source: null,
    },
    {
      title: 'Effectiveness',
      description:
  <Text fontSize="inherit" mb={2}>(Quality / Quantity) - Indicates how good the current network is for the amount of lane km work done in the last three years. The normalised result is compared to the rest of the peers.</Text>,
      source: null,
    },
    {
      title: null,
      description:
  <Box mb={2}>
    <Text fontSize="inherit" mb={2}>RCAs are peer grouped with similar RCAs based on a combination of urban/rural split and traffic volume in their network. Regions are all compared to each other in a single peer group. The results are classed into:</Text>
    <IndicatorLegend items={e3Legend} />
  </Box>,
      source:
  <Text fontSize="inherit" as="span">
    Calculated by Road Efficiency Group within Transport Insights.
  </Text>,
    },
  ],
};

function E3ReportHeader({ ...rest }) {
  const {
    data: e3KpiData, isLoading,
  } = useE3Kpi();

  const [colours, setColours] = useState([]);
  const [labels, setLabels] = useState([]);

  useEffect(() => {
    if (e3KpiData?.data) {
      setColours(Object.values(e3KpiData.data).map((x) => colourMap[x] || colourMap.default));
      setLabels(Object.keys(e3KpiData.data || []).map((x) => labelMap[x]));
    } else {
      setColours([]);
      setLabels([]);
    }
  }, [e3KpiData?.data]);

  return (
    <ReportHeader
      title="Value for Money, Efficiency and Effectiveness"
      subtitle="Sealed Network Benchmarking"
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center" pr={4}>
        <SplitCircleIndicator
          size={70}
          colours={colours}
          labels={labels}
          isLoading={isLoading && !e3KpiData}
        />
      </Flex>
    </ReportHeader>
  );
}

export default E3ReportHeader;
